import React, { useEffect } from 'react';
import '@resources/assets/styles/loading.scss';
import ContentHeader from '@components/_commons/ContentHeader';
import { Box, Drawer, Grid2, SelectChangeEvent } from '@mui/material';
import '@resources/assets/styles//ibt.scss';
import { IBTResultList } from '../../../components/services/ibt';
import { Outlet, useParams } from 'react-router-dom';
import IBTHeader from '@components/services/ibt/IBTHeader';
import IBTSidebar from '@components/services/ibt/IBTSidebar';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setShowSidebarList } from '@modules/ibt';

function IBTUsage(props) {

    const { quiz_id } = useParams()
    const dispatch = useDispatch()
    const showSidebarList = useSelector((state) => state.ibt.showSidebarList)
    console.log('useParams test: ', !quiz_id, quiz_id, typeof quiz_id)

    useEffect(() => {
        console.log('init page!')
    }, [])

    return (
        <Box className='wrapper-content'>
            <Box id="content-header" className='content-header'>
                <ContentHeader />
            </Box>
            <Box id='ibt-usage-container' className='content-body'>
                <IBTHeader />

                <Grid2 id='ibt-body-container' container>

                    <Grid2 className='border-right-1 section-scroll' size={{ xs:0, sm: 0, md: 0, lg: 3, xl: 3 }} sx={{ display: { 'xs': 'none', 'lg': 'block' }}}>
                        <IBTSidebar />
                    </Grid2>
                    <Grid2 className='section-scroll' size={{ xs:12, sm: 12, md: 12, lg: 9, xl: 9 }}>
                        <IBTResultList />
                    </Grid2>
                    <Drawer
                        anchor="left"
                        open={ showSidebarList }
                        onClose={() => dispatch(setShowSidebarList(false))}
                        sx={{
                            '& .MuiDrawer-paper': {
                                width: 280,
                                zIndex: 1200,
                            },
                        }}
                    >
                        <IBTSidebar />
                    </Drawer>
                </Grid2>

                
            </Box>
        </Box>
    );
}

export default IBTUsage;